import { GET_MEMEBER_INFO_LOADING, POST_MEMBER_INFO_LOADING, MEMBER_DATA_SUCCESS, MEMBER_DATA_ERROR } from "../actions/actionMember";

const initialState = {
    MemberInfo: {},
    loading: false,
    MemberInfoError: ''
};

function reducerMember(state = initialState, action) {
    switch (action.type) {
        case GET_MEMEBER_INFO_LOADING: {
            return {
                ...state,
                loading: true,
                MemberInfo: {},
                MemberInfoError: ''
            };
        }

        case POST_MEMBER_INFO_LOADING: {
            return {
                ...state,
                loading: true,
                MemberInfo: {},
                MemberInfoError: ''
            };
        }

        case MEMBER_DATA_SUCCESS: {
            return {
                ...state,
                loading: false,
                MemberInfo: action.payload[0],
                MemberInfoError: ''
            };
        }
        case MEMBER_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                MemberInfo: {},
                MemberInfoError: action.error
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerMember;